import { StrictMode } from 'react'

import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import ReactDOM from 'react-dom/client'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'

import '@/modules/sentry/init.ts'

import './listeners.ts'
import './models'
import './modules/vault/imagesErrorHandler.ts'
import { appRoutes } from './routes'
import './styles/index.css'

const root = document.getElementById('root') as HTMLElement
const router = createBrowserRouter(appRoutes)

if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      // const registrations = await navigator.serviceWorker.getRegistrations()
      //
      // for (const registration of registrations) {
      //   const success = await registration.unregister()
      //
      //   console.log('SW: unregistered:', success)
      // }

      await navigator.serviceWorker.register('/media-cache.service-worker.js', {
        scope: '/',
        type: 'module',
      })
    } catch (error) {
      console.error(`SW: Registration failed with ${error}`)
    }
  })
}

ReactDOM.createRoot(root).render(
  <StrictMode>
    <DndProvider backend={HTML5Backend}>
      <RouterProvider router={router} />
    </DndProvider>
  </StrictMode>,
)
